import React, { useEffect, useState } from "react";
import styles from "./BasketDrawer.module.scss";
import heartIcon from "../../../assets/images/product-section/icon/heart.svg";
import trushIcon from "../../../assets/images/basket/TrashSimple.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../redux/store";
import { fetchBasketData } from "../../../redux/Slices/BasketSlice";
import BasketServices from "../../basket/basketService/BasketService";
import HomeServices from "../../../pages/home/homeService/HomeService";
import ReactLoading from "react-loading";
import { Modal } from "antd";
import { AxiosError } from "axios";
import InfoModalComponent from "../../modalMessage/InfoModalMessage";

interface BasketDrawerProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function BasketDrawer({
  isOpen,
  setIsOpen,
}: BasketDrawerProps): JSX.Element {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [wishlistLoading, setWishlistLoading] = useState<number | null>(null);
  const dispatch = useDispatch<AppDispatch>();
  const [total, setTotal] = useState({
    discounted_price: 0,
    total_discount_price: 0,
    total_price: 354,
  });
  const { basketItems, status } = useSelector(
    (state: RootState) => state.basket
  );
  const selectedLanguage = useSelector(
    (state: RootState) => state.language.selectedLanguage?.code
  );
  const handleNavigateToBasket = () => {
    navigate("/basket");
    setIsOpen(false);
  };

  const DeletItem = async (id: number) => {
    setLoading(true);
    try {
      await BasketServices.DeleteBasket(id);
      dispatch(fetchBasketData());
    } catch (err: any) {
      console.error("Delete error:", err);
    } finally {
      setLoading(false);
    }
  };

  const ClearItem = async () => {
    setLoading(true);
    try {
      await BasketServices.ClearBasket();
      dispatch(fetchBasketData());
    } catch (err: any) {
      console.error("Clear basket error:", err);
    } finally {
      setLoading(false);
    }
  };
  const translations = useSelector(
    (state: RootState) => state.translations.data
  );
  const handleAddToWishlist = async (id: number, event: React.MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setWishlistLoading(id);

    try {
      const response = await HomeServices.addProductToWishlist({
        product_id: id,
      });
      if (response.status) {
        console.log("Added to wishlist successfully");
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        InfoModalComponent({
          message: translations?.login_before_adding,
          title: translations?.info,
          okText: translations?.okay,
          loginText: translations?.login,
        });
      } else {
        console.error("Wishlist error:", error);
      }
    } finally {
      setWishlistLoading(null);
    }
  };

  useEffect(() => {
    const TotalItem = async () => {
      try {
        const res = await BasketServices.TotalBasket();
        setTotal({
          discounted_price: res.discounted_price,
          total_discount_price: res.total_discount_price,
          total_price: res.total_price,
        });
      } catch (err: any) {
        console.error("Total basket error:", err);
      }
    };
    TotalItem();
  }, [basketItems]);

  useEffect(() => {
    dispatch(fetchBasketData());
  }, [selectedLanguage]);

  return (
    <div className={styles.overlay} onClick={() => setIsOpen(false)}>
      <div className={styles.cart_drawer} onClick={(e) => e.stopPropagation()}>
        {basketItems?.length === 0 ? (
          <div className={styles.empty_cart}>
            <div>
              <p className={styles.empty_title}>
                {translations?.empty_message}
              </p>
              <button
                className={styles.continue_shopping}
                onClick={() => setIsOpen(false)}
              >
                {translations?.continue_shopping}
              </button>
            </div>
          </div>
        ) : (
          <>
            <h2 style={{ fontWeight: "550" }}>{translations?.basket}</h2>
            <div className={styles.cart_items}>
              <button className={styles.clearItems} onClick={() => ClearItem()}>
                <img src={trushIcon} alt="Remove from Cart" />
                <p className={styles.clearText}>{translations?.clear_all}</p>
              </button>
              {loading ? (
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <ReactLoading
                    type={"spin"}
                    color={"#3983f0"}
                    height={40}
                    width={40}
                  />
                </div>
              ) : (
                basketItems.map((item) => (
                  <div key={item.id} className={styles.cart_item}>
                    <img
                      src={item.cover_image}
                      alt={item.name}
                      className={styles.cart_item_image}
                    />
                    <div className={styles.cart_item_details}>
                      <div className={styles.cart_name_price}>
                        <p style={{color:"#000"}} className={styles.title}>{item.name}</p>
                        <div>
                          {item.discount_price ? (
                            <>
                              <p style={{color:"#000"}} className={styles.prev_price}>
                                <span>{item.price}</span> azn
                              </p>
                              <p style={{color:"#000"}} className={styles.current_price}>
                                {item.discount_price} azn
                              </p>
                            </>
                          ) : (
                            <p style={{color:"#000"}} className={styles.current_price}>
                              {item.price} azn
                            </p>
                          )}
                        </div>
                      </div>
                      <div className={styles.amount_buttons}>
                        <p>{item.quantity} ədəd</p>
                        <div className={styles.buttons_container}>
                          <button
                            onClick={(e) => handleAddToWishlist(item.id, e)}
                          >
                            {wishlistLoading === item.id ? (
                              <ReactLoading
                                type={"spin"}
                                color={"#de3d31"}
                                height={20}
                                width={20}
                              />
                            ) : (
                              <img src={heartIcon} alt="Add to Wishlist" />
                            )}
                          </button>
                          <button onClick={() => DeletItem(item.id)}>
                            <img src={trushIcon} alt="Remove from Cart" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>

            <div className={styles.cart_summary}>
              {total.total_discount_price !== 0 && (
                <div style={{color:"#000"}} className={styles.total}>
                  <span>{translations?.total}:</span>
                  <p>{total.total_price} AZN</p>
                </div>
              )}
              {total.total_discount_price !== 0 && (
                <div style={{color:"#000"}} className={styles.discount}>
                  <span>{translations?.discount}: </span>
                  <p>-{total.discounted_price} AZN</p>
                </div>
              )}
              <div style={{color:"#000"}} className={styles.total_discount}>
                <span>
                  {total.total_discount_price === 0
                    ? `${translations?.total}:`
                    : `${translations?.final_price}:`}
                </span>
                <p style={{ color: "#2767E9" }}>
                  {total.total_discount_price === 0
                    ? total.total_price
                    : total.total_discount_price}{" "}
                  AZN
                </p>
              </div>
            </div>
            {/* <button className={styles.order_button}>Sifarişi et</button> */}
            <button
              onClick={handleNavigateToBasket}
              className={styles.view_cart_button}
            >
              {translations?.view_cart}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
